import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

// Lade-Zeichen: WJ. mit pulsierendem Punkt — höchstens einmal pro Sitzung
// und höchstens 600 ms (450 ms sichtbar + 150 ms Ausblenden). Inhalte laden
// dahinter unabhängig weiter, der Loader verzögert nichts.
export const PageLoader = () => {
  const [done, setDone] = useState(() => sessionStorage.getItem("wj-loader-seen") === "1");

  useEffect(() => {
    if (done) return;
    const timer = setTimeout(() => {
      sessionStorage.setItem("wj-loader-seen", "1");
      setDone(true);
    }, 450);
    return () => clearTimeout(timer);
  }, [done]);

  return (
    <AnimatePresence>
      {!done && (
        <motion.div
          exit={{ opacity: 0 }}
          transition={{ duration: 0.15, ease: "easeInOut" }}
          className="fixed inset-0 z-[90] flex items-center justify-center bg-obsidian"
          data-testid="page-loader"
        >
          <p className="font-serif text-4xl font-light tracking-tight text-bone">
            WJ
            <motion.span
              animate={{ opacity: [1, 0.15, 1], scale: [1, 0.7, 1] }}
              transition={{ duration: 0.45, repeat: 1, ease: "easeInOut" }}
              className="inline-block text-ember"
            >
              .
            </motion.span>
          </p>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
